<template>
    <ASelect
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih Kategori"
        allow-clear
        show-search
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.params.q = null)"
        @select="() => (state.params.q = null)"
        v-bind="$attrs"
        :filter-option="false"
        :loading="state.loading"
        :show-arrow="true"
        @focus="() => {state.isFirstLoad && fetchData(); state.isFirstLoad = false;}">
        <ASelectOption v-for="item in state.data" :key="item.value" :label="item.value" :title="item.value">
            <span v-html="highlight(item.value)"></span>
        </ASelectOption>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, keyBy, merge, pickBy, values } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        group: {
            type: [Array, Number, String],
            default: null,
        },
        joinOptions: {
            type: [Array],
            default: () => [],
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: `/api/filter/suggestion-header`,
            loading: false,
            isFirstLoad: true,
            data: [],
            params: {
                q: '',
                group: props.group,
            },
        })

        const fetchData = () => {
            state.loading = true
            apiClient.get(state.endpoint, { params: pickBy(state.params) })
                .then(({ data }) => {
                    const options = props.joinOptions.filter(item => item.value !== undefined)
                    if (options.length > 0) {
                        data = values(merge(keyBy(options, 'value'), keyBy(data, 'value')))
                    }
                
                    state.data = data
                })
                .finally(() => {
                    state.loading = false
                })
        }

        watch(() => [props.group], ([group]) => {
            Object.assign(state.params, { group })
        })

        watch(state.params, debounce(() => {
            fetchData()
        }, 300))

        const onSearch = value => {
            state.params.q = value
        }

        const highlight = value => {
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
            fetchData,
        }
    },
}
</script>